import React from 'react'
import TextField from 'material-ui/TextField'
import { MenuItem } from 'material-ui/Menu'


const MyTextField = ({ input: { name, onChange, value, ...restInput }, label, meta, options, ...rest }) => {
  return(
    <TextField
      {...rest}
      id={name}
      //name={name}
      label={label}
      helperText={meta.touched ? meta.error : undefined}
      error={meta.error && meta.touched}
      inputProps={restInput}
      onChange={onChange}
      value={value}
    >
      {options && options.map(option => {
        return (
          <MenuItem key={option.value} value={option.value} disabled={option.disabled} style={{ display: option.hidden ? 'none' : 'block' }}>{option.label}</MenuItem>
        )
      })
      }
    </TextField>
  )
}

export default MyTextField


// WEBPACK FOOTER //
// ./src/components/TextField/TextField.jsx